import { render, staticRenderFns } from "./MySecretPrescriptionWrite.vue?vue&type=template&id=a808449e"
import script from "./MySecretPrescriptionWrite.vue?vue&type=script&lang=js"
export * from "./MySecretPrescriptionWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports